// extracted by mini-css-extract-plugin
module.exports = {"container":"NsDrawer_container_2JaeQ","scrim":"NsDrawer_scrim_arQ0L","content":"NsDrawer_content_3vQtl"};